import { BrowserRouter, HashRouter, useLocation } from "react-router-dom";
import AppRoutes from "./Routes";

import './App.css';
import Header from "./Components/Header/Header";
import ScrollToTop from "./Components/ScrollToTop";
import ExpiryBanner from "./Components/Client/ExpiryBanner";
import useHeartbeat from "./Components/Client/useHeartbeat";
import useSectionTrackingFlush from "./Components/Client/useSectionTrackingFlush";
import useInteractionTrackingFlush from "./Components/Client/useInteractionTrackingFlush";
import InteractionTracker from "./Components/Client/InteractionTracker";
import { isClientLoggedIn } from "./Components/Client/clientApi";

const Router = process.env.REACT_APP_ELECTRON === "true" ? HashRouter : BrowserRouter;

function Layout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isLoginRoute = location.pathname === "/login";

  const loggedIn = isClientLoggedIn();

  useHeartbeat(loggedIn);
  useSectionTrackingFlush(loggedIn);
  useInteractionTrackingFlush(loggedIn);

  return (
    <>
      <ScrollToTop />
      <ExpiryBanner />
      {!isAdminRoute && !isLoginRoute && <Header />}
      <InteractionTracker>
        <AppRoutes />
      </InteractionTracker>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}